import { useFormik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import { httpReauest } from "../../../utils/httpRequest";
import * as Yup from "yup";
import { BASE_URL } from "../../../config";
import Loading from "../Loading";
import { FaTrash } from "react-icons/fa6";
import { Editor } from "@tinymce/tinymce-react";
import ReactQuill from "react-quill";

const CreateProductForm = () => {
  const [img, setImg] = useState();
  const [images, setImages] = useState([]);
  const [previews, setPreview] = useState([]);
  const [previewImg, setPreviewImg] = useState();
  const [categorys, setCategorys] = useState();
  const [subCategorys, setsubCategorys] = useState([]);
  const [loading, setloading] = useState();
  const [productImages, setProductImages] = useState([]);
  const [products, setproducts] = useState([
    {
      color: "",
      balance: "",
      price: "",
      special_price: "",
      storage: "",
      size: "",
    },
  ]);
  const [catalog, setCatalog] = useState();
  const [single, setsingle] = useState("notselect");
  const [video, setVideo] = useState();

  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      name: Yup.string().required("الزامی است"),
      url: Yup.string().required("الزامی است"),
    });
  };

  function handleProductImages(e, productIndex) {
    const files = Array.from(e.target.files);
    let validImages = [];

    files.forEach((file) => {
      if (file.size > 2 * 1024 * 1024) {
        toast.error("حجم تصویر باید کمتر از 2 مگابایت باشد");
      } else {
        validImages.push(file);
      }
    });

    if (validImages.length) {
      // اضافه کردن فایل‌ها به محصول
      setProductImages((prev) => {
        const updated = [...prev];
        updated[productIndex] = [
          ...(updated[productIndex] || []),
          ...validImages,
        ];
        return updated;
      });

      // ساخت پیش‌نمایش‌ها به صورت async-safe
      Promise.all(
        validImages.map(
          (file) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(file);
            })
        )
      ).then((previewsData) => {
        setPreview((prev) => {
          const updated = [...prev];
          if (!updated[productIndex]) updated[productIndex] = [];
          updated[productIndex] = [...updated[productIndex], ...previewsData];
          return updated;
        });
      });
    }
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      desc: "",
      category: "",
      subCategory: "",
      more_desc: "",
      url: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      setloading(true);
      const user = JSON.parse(localStorage.getItem("user"));

      if (!img) {
        return toast.error("تصویر کاور اجباری است");
      }

      const formdata = new FormData();

      formdata.append("name", values.name);
      formdata.append("url", values.url);
      formdata.append("category", values.category);
      formdata.append("subCategory", values.subCategory);
      formdata.append("desc", values.desc);
      formdata.append("more_desc", values.more_desc);

      // آماده‌سازی محصولات با imagesCount
      const productsWithCounts = products.map((p, i) => ({
        ...p,
        imagesCount: productImages[i]?.length || 0,
      }));
      formdata.append("products", JSON.stringify(productsWithCounts));
      formdata.append("cover", img, img?.name);

      // افزودن تمام تصاویر به ترتیب
      productImages.forEach((group) => {
        if (group && group.length) {
          group.forEach((file) => {
            formdata.append("images", file, file.name);
          });
        }
      });

      await fetch(BASE_URL + "/product", {
        method: "POST",
        body: formdata,
        headers: { "x-access-token": user.token },
      })
        .then(async (dat) => {
          const res = await dat.json();
          if (dat?.status == 201) {
            toast.success("محصول ساخته شد");
            setloading(false);
            formik.resetForm();
            setImg(null);
            setImages([]);
            setPreviewImg(null);
            setPreview([]);
            setCatalog(null);
            setVideo(null);
            setProductImages([]);
          } else {
            setloading(false);
            toast.error(res.message);
          }
        })
        .catch((err) => {
          setloading(false);
          toast.error(err.response?.data?.message);
        });
    },
  });

  useEffect(() => {
    getData();
  }, []);

  function handleImages(e) {
    const fils = e.target.files;
    if (fils) {
      for (let index = 0; index < fils?.length; index++) {
        if (fils[index].size > 2031517) {
          toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
        } else {
          setImages((current) => [...current, fils[index]]);
          setPreviwImages(fils[index]);
        }
      }
    }
  }

  console.log(previews);

  async function setPreviwImages(i) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreview((current) => [...current, reader.result]);
    };
    reader.readAsDataURL(i);
  }

  async function setPreviwImage(imgInput) {
    const reader = new FileReader();
    reader.onloadend = function () {
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(imgInput);
  }

  async function getData() {
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setCategorys(data?.data);
    });
  }

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  function handleChange(value) {
    formik.setFieldValue("more_desc", value);
  }

  function handleDeleteCategory(_id) {
    const filtered = formik.values.category.filter((item) => item !== _id);
    formik.setFieldValue("category", filtered);
  }

  async function handleAddCategory(_id) {
    formik.setFieldValue("category", _id);
    const res = await httpReauest("GET", "/category/" + _id, {}, {});
    setsubCategorys(res.data.data.categories);
  }

  function handleChangePrice(params, index) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    const newproducts = products.map((e, i) => {
      if (i === index) {
        return { ...e, price: formattedValue };
      } else {
        return { ...e };
      }
    });
    setproducts(newproducts);
  }
  function handleChangeSpecialPrice(params, index) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    const newproducts = products.map((e, i) => {
      if (i === index) {
        return { ...e, special_price: formattedValue };
      } else {
        return { ...e };
      }
    });
    setproducts(newproducts);
  }

  function handleChangeProduct(value, fild, index) {
    setproducts((prevProducts) => {
      const updatedProducts = [...prevProducts];
      updatedProducts[index] = {
        ...updatedProducts[index],
        [fild]: value,
      };
      return updatedProducts;
    });
  }

  function handleImg(e) {
    const fils = e.target.files[0];
    if (fils.size > 2031517) {
      toast.error("حجم فایل باید کمتر از دو مگابایت باشد");
    } else {
      setImg(fils);
      setPreviwImage(fils);
    }
  }

  return (
    <div>
      <h2 className="text-[20px] mb-8 font-bold p-3">فرم ایجاد محصول</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
      >
        <>
          <span className="relative">
            <input
              id="name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="w-full form-brand h-[48px]"
            />
            {formik.errors.name && formik.touched.name && (
              <small style={{ color: "red", fontSize: "14px" }}>
                {formik.errors.name}
              </small>
            )}
            <p className="on-border font-bold">نام محصول*</p>
          </span>
          <span className="relative">
            <input
              id="url"
              name="url"
              value={formik.values.url}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="w-full form-brand h-[48px]"
            />
            <p className="on-border font-bold">url*</p>
          </span>

          <span className="relative">
            <select
              id="category"
              name="category"
              onChange={(e) => handleAddCategory(e.target.value)}
              className={` w-full form-brand h-[48px]`}
            >
              <option></option>
              {categorys?.map((e) => (
                <option value={e._id}>{e.name}</option>
              ))}
            </select>
            {formik.errors.category && formik.touched.category && (
              <small style={{ color: "red", fontSize: "14px" }}>
                {formik.errors.category}
              </small>
            )}
            <p className="on-border font-bold">دسته بندی *</p>
          </span>
          {subCategorys.length ? (
            <span className="relative">
              <select
                id="subCategory"
                name="subCategory"
                onChange={formik.handleChange}
                className={` w-full form-brand h-[48px]`}
              >
                <option></option>
                {subCategorys?.map((e) => (
                  <option value={e._id}>{e.name}</option>
                ))}
              </select>
              {formik.errors.subCategory && formik.touched.subCategory && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.subCategory}
                </small>
              )}
              <p className="on-border font-bold">دسته بندی داخلی*</p>
            </span>
          ) : null}
          <span className="relative">
            <textarea
              id="desc"
              name="desc"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={` w-full form-brand h-[78px]`}
            />
            <p className="on-border font-bold">توضیح کوتاه</p>
          </span>
          <label
            htmlFor="img"
            className="relative w-full border-dashed border rounded-[10px] p-3 h-[200px] cursor-pointer border-[#444]"
          >
            {previewImg ? (
              <img
                src={previewImg}
                className="w-full h-full object-contain"
                alt=""
              />
            ) : (
              <FaPlus className="center" size={30} />
            )}
            <p className="on-border font-bold">تصویر</p>
          </label>

          <input
            onChange={(e) => {
              handleImg(e);
            }}
            type="file"
            className="hidden"
            id="img"
            accept="image/png, image/jpg, image/jpeg"
          />
          <>
            {products?.map((item, index) => (
              <span className="col-span-full grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
                <h3 className="col-span-full text-[22px] font-bold">
                  محصول {index + 1}
                </h3>
                <span className="relative">
                  <input
                    id={`color[${index}]`}
                    name={`color[${index}]`}
                    value={products[index].color}
                    onChange={(e) =>
                      handleChangeProduct(e.target.value, "color", index)
                    }
                    type="text"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">اسم رنگ*</p>
                </span>
                <span className="relative">
                  <input
                    id={`balance[${index}]`}
                    name={`balance[${index}]`}
                    value={products[index].balance}
                    onChange={(e) =>
                      handleChangeProduct(e.target.value, "balance", index)
                    }
                    onBlur={formik.handleBlur}
                    type="text"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">تعداد*</p>
                </span>
                <span className="relative">
                  <input
                    id={`storage[${index}]`}
                    name={`storage[${index}]`}
                    value={products[index].storage}
                    onChange={(e) =>
                      handleChangeProduct(e.target.value, "storage", index)
                    }
                    onBlur={formik.handleBlur}
                    type="text"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">حافظه</p>
                </span>
                <span className="relative">
                  <input
                    id={`size[${index}]`}
                    name={`size[${index}]`}
                    value={products[index].size}
                    onChange={(e) =>
                      handleChangeProduct(e.target.value, "size", index)
                    }
                    onBlur={formik.handleBlur}
                    type="text"
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="on-border font-bold">سایز</p>
                </span>
                <span className="relative">
                  <input
                    id={`price[${index}]`}
                    name={`price[${index}]`}
                    value={products[index].price}
                    onChange={(e) => handleChangePrice(e, index)}
                    className="w-full form-brand h-[48px]"
                  />
                  <p className="absolute translate-y-[-50%] top-[24px] left-4">
                    AED
                  </p>
                  <p className="on-border font-bold">قیمت محصول*</p>
                </span>
                <span className="relative">
                  <input
                    id={`special_price[${index}]`}
                    name={`special_price[${index}]`}
                    value={products[index].special_price}
                    onChange={(e) => handleChangeSpecialPrice(e, index)}
                    className="w-full form-brand h-[48px]"
                  />

                  <p className="absolute translate-y-[-50%] top-[24px] left-4">
                    AED
                  </p>
                  <p className="on-border font-bold">
                    قیمت با تخفیف(در صورتی که تخفیف دارد)
                  </p>
                </span>
                <span className="relative col-span-full">
                  <input
                    multiple
                    type="file"
                    id={`images-${index}`}
                    accept="image/*"
                    onChange={(e) => handleProductImages(e, index)}
                    className="hidden"
                  />
                  <label
                    htmlFor={`images-${index}`}
                    className="w-full border-dashed border rounded-[10px] p-3 h-[310px] gap-2 cursor-pointer border-[#444] flex flex-wrap items-start justify-start"
                  >
                    {previews[index]?.length ? (
                      previews[index].map((priviewIndex) => (
                        <img
                          src={priviewIndex} // فقط تصویر اول برای پیش‌نمایش
                          className="w-[150px] h-[140px] object-contain"
                          alt=""
                        />
                      ))
                    ) : (
                      <FaPlus size={30} className="center" />
                    )}
                  </label>
                  <p className="on-border font-bold">تصاویر محصول</p>
                </span>
              </span>
            ))}
            <span className="flex col-span-full gap-2 items-center">
              <FaPlus
                className="cursor-pointer"
                onClick={() => {
                  setproducts((cur) => [
                    ...cur,
                    {
                      color: "",
                      balance: "",
                      price: "",
                      special_price: "",
                      storage: "",
                      size: "",
                    },
                  ]);
                }}
                color="black"
                size={32}
              />
              {products?.length > 1 && (
                <FaTrash
                  onClick={() =>
                    setproducts((prevProducts) =>
                      prevProducts.filter((_, i) => i !== products.length - 1)
                    )
                  }
                  className="cursor-pointer"
                  color="red"
                  size={32}
                />
              )}
            </span>
          </>

          <span dir="ltr" className="col-span-full">
            <h2 className="title text-right">:توضیح</h2>
            <ReactQuill
              value={formik.values.more_desc}
              modules={{
                toolbar: [
                  [{ header: [1, 2, false], font: ["Opens Sans"] }, {}],
                  ["bold", "italic", "underline", "strike", "blockquote"],
                  [
                    { list: "ordered" },
                    { list: "bullet" },
                    { indent: "-1" },
                    { indent: "+1" },
                  ],
                  ["link", "image", "code"],
                  ["clean"],
                ],
              }}
              formats={formats}
              onChange={handleChange}
            />
          </span>
          <input
            onChange={(e) => {
              handleImages(e);
            }}
            type="file"
            className="hidden"
            id="images"
            accept="image/png, image/jpg, image/jpeg"
          />
          {loading ? (
            <Loading />
          ) : (
            <button type="submit" className="btn-brand">
              ارسال
            </button>
          )}
        </>
      </form>
    </div>
  );
};

export default CreateProductForm;
